module.exports = __webpack_public_path__ + "img/product-shot_06_loading.48724048.jpg";